<span [matTooltip]="text" [innerHtml]="text|truncate"></span>
